import { useAppStore } from '../state/appStore';
import { translate } from '../i18n';

/** Hook de traducción ligado al idioma activo. */
export function useT(): (key: string) => string {
  const lang = useAppStore((s) => s.lang);
  return (key: string) => translate(lang, key);
}

/** Convierte km/h a la unidad elegida y devuelve [valor, etiqueta]. */
export function useSpeedFormat(): (kmh: number) => [number, string] {
  const units = useAppStore((s) => s.settings.units);
  return (kmh: number) =>
    units === 'mph' ? [Math.round(kmh * 0.621371), 'mph'] : [Math.round(kmh), 'km/h'];
}
